"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.languageToISO = void 0;
var language_to_iso_map_1 = require("./language-to-iso.map");
Object.defineProperty(exports, "languageToISO", { enumerable: true, get: function () { return language_to_iso_map_1.languageToISO; } });
